"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportsIcon = void 0;
const react_1 = __importDefault(require("react"));
const Theme_1 = require("../../Theme");
const ReportsIcon = (_a) => {
    var { onClick } = _a, props = __rest(_a, ["onClick"]);
    return (react_1.default.createElement("svg", Object.assign({ width: "11", height: "13", viewBox: "0 0 11 13", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { onClick: onClick }),
        react_1.default.createElement("path", { d: "M9 13H2C1.46957 13 0.96101 12.7891 0.585938 12.4141C0.210865 12.039 0 11.5304 0 11V2C0 1.46957 0.210865 0.96101 0.585938 0.585938C0.96101 0.210865 1.46957 0 2 0H9C9.53043 0 10.039 0.210865 10.4141 0.585938C10.7891 0.96101 11 1.46957 11 2V11C11 11.5304 10.7891 12.039 10.4141 12.4141C10.039 12.7891 9.53043 13 9 13ZM2 9V10H9V9H2ZM2 6V7H9V6H2ZM2 3V4H9V3H2Z", fill: Theme_1.theme.palette.BLUE_100 })));
};
exports.ReportsIcon = ReportsIcon;
exports.ReportsIcon.defaultProps = {
    onClick: () => { }
};
